import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import strings from '../../components/locales/';
import moment from 'moment';
import ObjGeneral from '../function/';
import constants from '../function/constants';
/* Local store */
import { localStoreFN } from '../../store/localStorage';

/* Actions */
import * as accountVehicleActions from '../../actions/account_vehicle/index';
import * as tagsActions from '../../actions/common/tags/index';
import * as datasourceActions from '../../actions/datasource/index';

/*Style*/
import '../../../../public/style/dashboard.scss';

/* Components */
import Header from '../../components/account_vehicle/header';
import Title from '../../components/account_vehicle/title';
import Table from '../../components/account_vehicle/table';
import Buttons from '../../components/account_vehicle/buttons';
import ModalCreate from '../../components/account_vehicle/modalCreate';
import ModalEdit from '../../components/account_vehicle/modalEdit';
import ModalActive from '../../components/account_vehicle/modalActive';
import ModalDelete from '../../components/account_vehicle/modalDelete';
import ModalDownload from '../../components/account_vehicle/modalDownload';
import ModalUpdate from '../../components/account_vehicle/modalUpdate';
import Expired from '../expired/index';

import Loading from '../../components/common/loading';
import Message from '../../components/common/message';

class AccountVehicle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pag: 1,
      sort: true,
      homologation: { a: true, b: false, c: false, d: false, e: false },
      modal: false,
      modalEdit: false,
      modalActive: false,
      modalDelete: false,
      modalDownload: false,
      modalUpdate: false,
      activeUpdate: true,
      tags: [],
      arrTags: [],
      config: {
        name: '',
        code: '',
        extendedProperties: [],
        tags: [],
        hom: []
      }
    };
  }

  async componentDidMount() {
    /* Setting */
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('vehicles');

    if (permit) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('account')) {
          await this.props.actions.fetchAccountVehicleExtendedPropertiesApi({});
          await this.props.datasourceActions.fetchDatasourceApi({});
          await this.props.actions.fetchAccountVehicleApi({
            pag: this.state.pag,
            homologation: this.state.homologation
          });
          await this.props.actions.fetchAccountVehicleCountApi({
            homologation: this.state.homologation
          });
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

  componentWillUnmount() {
    this.props.actions.resetAccountVehicle();
  }

  handleSearch = async event => {
    if (!this.props.loading) {
      const value = event.target.value;
      this.setState({ pag: 1 });
      await this.props.actions.fetchAccountVehicleNoLoadingApi({
        tags: this.state.arrTags,
        sort: this.state.sort,
        filter: value,
        pag: 1,
        concat: false,
        homologation: this.state.homologation
      });
      await this.props.actions.fetchAccountVehicleCountApi({
        tags: this.state.arrTags,
        filter: value,
        homologation: this.state.homologation
      });
    }
  };

  handleScroll = async event => {
    if (
      this.state.pag < this.props.count.pages &&
      this.state.modalEdit == false &&
      this.state.modal == false
    ) {
      const scroll = event.target.scrollTop;
      const max = event.target.scrollHeight - event.target.offsetHeight;
      const value = document.getElementById('search').value;
      if (scroll >= max) {
        this.setState({ pag: this.state.pag + 1 });
        const pag = this.state.pag + 1;
        await this.props.actions.fetchAccountVehicleNoLoadingApi({
          tags: this.state.arrTags,
          filter: value,
          pag: pag,
          concat: true,
          sort: this.state.sort,
          homologation: this.state.homologation
        });
      }
    }
  };

  handleSort = async event => {
    this.setState({ pag: 1 });
    const value = document.getElementById('search').value;
    const sort = this.state.sort ? false : true;
    await this.props.actions.fetchAccountVehicleNoLoadingApi({
      tags: this.state.arrTags,
      filter: value,
      sort: sort,
      pag: 1,
      concat: false,
      homologation: this.state.homologation
    });
    this.setState({ sort: this.state.sort ? false : true });
  };

  handleSelect = async event => {
    const element = event.target;
    element.classList.toggle('select');
  };

  handleHomologation = async event => {
    const select = event.target.dataset.select;
    document.getElementById('select-filter').innerHTML = `<span>Mostrar:</span><div>${event.target.innerHTML}</div>`;
    const value = document.getElementById('search').value;
    let obj = {};
    if (select == 'a') {
      this.setState({
        homologation: { a: true, b: false, c: false, d: false, e: false }
      });
      obj = { a: true, b: false, c: false, d: false, e: false };
    } else if (select == 'b') {
      this.setState({
        homologation: { a: false, b: true, c: false, d: false, e: false }
      });
      obj = { a: false, b: true, c: false, d: false, e: false };
    } else if (select == 'c') {
      this.setState({
        homologation: { a: false, b: false, c: true, d: false, e: false }
      });
      obj = { a: false, b: false, c: true, d: false, e: false };
    } else if (select == 'd') {
      this.setState({
        homologation: { a: false, b: false, c: false, d: true, e: false }
      });
      obj = { a: false, b: false, c: false, d: true, e: false };
    } else if (select == 'e') {
      this.setState({
        homologation: { a: false, b: false, c: false, d: false, e: true }
      });
      obj = { a: false, b: false, c: false, d: false, e: true };
    }
    await this.props.actions.fetchAccountVehicleNoLoadingApi({
      tags: this.state.arrTags,
      filter: value,
      sort: this.state.sort,
      pag: 1,
      concat: false,
      homologation: obj
    });
    await this.props.actions.fetchAccountVehicleCountApi({
      tags: this.state.arrTags,
      filter: value,
      homologation: obj
    });
  };

  handleSubmit = async event => {
    const objSett = JSON.parse(this.props.setting.value);
    const countList = document.querySelectorAll('[data-list]').length;
    const countHom = document.querySelectorAll('[data-hom]').length;
    const code = document.getElementById('code').value;
    const name = document.getElementById('name').value;
    var extendedProps = [];

    if (this.props.extendedProperties) {
      this.props.extendedProperties.map((item, i) => {
        var property = document.getElementById('create-extended-property-' + item.id);
        if (property && property.value) {
          var formatValue = property.value;
          if (item.dataType == 'DATE') {
            formatValue = moment(formatValue, this.props.language.account.date.format).format('YYYY-MM-DD');
          }
          extendedProps.push({
            id: item.id,
            value: formatValue
          });
        }
      });
    }

    let i, e;
    let countParents;
    let tags = [];
    let objTags;
    for (i = 0; i <= countList - 1; i++) {
      countParents = document.querySelectorAll(`[data-parent="list-${i}"]`).length;
      for (e = 0; e <= countParents - 1; e++) {
        if (document.getElementById(`list-${i}-${e}`).classList.contains('select')) {
          objTags = {};
          objTags.tag = document.getElementById(`list-${i}-${e}`).innerHTML;
          tags.push(objTags);
        }
      }
    }
    let input;
    let hom = [];
    let objHom;
    for (i = 0; i <= countHom - 1; i++) {
      input = document.getElementById(`hom-${i}`);
      if (input.value != '') {
        objHom = {};
        objHom.externalEntityId = input.value;
        objHom.dataSource = input.dataset.type;
        hom.push(objHom);
      }
    }

    const obj = {
      alias: name,
      code: code,
      extendedProperties: extendedProps,
      tags: tags,
      homologations: hom
    };
    const arr = [obj];
    await this.props.actions.handleVehicle({ vehicle: arr });
  };

  handleDelete = async event => {
    const code = document.getElementById('iddelete').value;
    await this.props.actions.handleDeleteVehicle({ id: code });
  };

  handleUpdate = async event => {
    const objSett = JSON.parse(this.props.setting.value);
    const countList = document.querySelectorAll('[data-listup]').length;
    const countHom = document.querySelectorAll('[data-homup]').length;
    const code = document.getElementById('codeup').value;
    const name = document.getElementById('nameup').value;
    const id = document.getElementById('id').value;
    var extendedProps = [];

    if (this.props.extendedProperties) {
      this.props.extendedProperties.map((item, i) => {
        var property = document.getElementById('edit-extended-property-' + item.id);
        if (property && property.value) {
          var formatValue = property.value;
          if (item.dataType == 'DATE') {
            formatValue = moment(formatValue, this.props.language.account.date.format).format('YYYY-MM-DD');
          }
          extendedProps.push({
            id: item.id,
            value: formatValue
          });
        }
      });
    }

    let i, e;
    let countParents;
    let tags = [];
    let objTags;
    for (i = 0; i <= countList - 1; i++) {
      countParents = document.querySelectorAll(`[data-parentup="list-${i}"]`).length;
      for (e = 0; e <= countParents - 1; e++) {
        if (document.getElementById(`listup-${i}-${e}`).classList.contains('select')) {
          objTags = {};
          objTags.tag = document.getElementById(`listup-${i}-${e}`).innerHTML;
          tags.push(objTags);
        }
      }
    }
    let input;
    let hom = [];
    let objHom;
    for (i = 0; i <= countHom - 1; i++) {
      input = document.getElementById(`homup-${i}`);
      if (input.value != '') {
        objHom = {};
        objHom.externalEntityId = input.value;
        objHom.dataSource = input.dataset.type;
        hom.push(objHom);
      }
    }

    const obj = {
      id: id,
      alias: name,
      code: code,
      extendedProperties: extendedProps,
      tags: tags,
      homologations: hom
    };
    const arr = [obj];
    await this.props.actions.handleUpdateVehicle({ vehicle: arr });
  };

  handleModal = async e => {
    e.stopPropagation();
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modal ? false : true;
      this.setState({ modal: reset });
      if (!reset) {
        this.props.actions.resetModalVehicle();
        if (this.props.statusSave == 200) {
          this.setState({ pag: 1 });
          this.setState({
            homologation: { a: true, b: false, c: false, d: false, e: false }
          });
          document.getElementById('search').value = '';
          await this.props.actions.fetchAccountVehicleApi({ pag: 1, homologation: { a: true } });
          await this.props.actions.fetchAccountVehicleCountApi({ homologation: { a: true } });
        }
      }
    }
  };

  handleModalDelete = async e => {
    e.stopPropagation();
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalDelete ? false : true;
      this.setState({ modalDelete: reset });
      if (!reset) {
        this.props.actions.resetModalVehicle();
        if (this.props.statusSave == 200) {
          this.setState({ pag: 1 });
          this.setState({
            homologation: { a: true, b: false, c: false, d: false, e: false }
          });
          document.getElementById('search').value = '';
          await this.props.actions.fetchAccountVehicleApi({ pag: 1, homologation: { a: true } });
          await this.props.actions.fetchAccountVehicleCountApi({ homologation: { a: true } });
        }
      } else {
        const obj = JSON.parse(e.target.dataset.datos);
        this.setState({
          config: {
            id: obj.id,
            name: obj.alias,
            code: obj.code,
            extendedProperties: obj.extendedProperties,
            tags: [],
            hom: []
          }
        });
      }
    }
  };

  handleModalActive = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalActive ? false : true;
      this.setState({ modalActive: reset });
      if (!reset) {
        this.props.actions.resetModalVehicle();
        if (this.props.statusSave == 200) {
          this.setState({ pag: 1 });
          this.setState({
            homologation: { a: true, b: false, c: false, d: false, e: false }
          });
          document.getElementById('search').value = '';
          await this.props.actions.fetchAccountVehicleApi({ pag: 1, homologation: { a: true } });
          await this.props.actions.fetchAccountVehicleCountApi({ homologation: { a: true } });
        }
      } else {
        const obj = JSON.parse(e.target.dataset.datos);
        this.setState({
          config: {
            id: obj.id,
            name: obj.alias,
            code: obj.code,
            extendedProperties: obj.extendedProperties,
            tags: [],
            hom: []
          }
        });
      }
    }
  };

  handleModalEdit = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalEdit ? false : true;
      this.setState({ modalEdit: reset });
      if (!reset) {
        this.setState({
          config: {
            name: '',
            code: '',
            extendedProperties: [],
            tags: [],
            hom: []
          },
          activeUpdate: true
        });
        this.props.actions.resetModalVehicle();
        if (this.props.statusSave == 200) {
          this.setState({ pag: 1 });
          this.setState({
            homologation: { a: true, b: false, c: false, d: false, e: false }
          });
          document.getElementById('search').value = '';
          await this.props.actions.fetchAccountVehicleApi({ pag: 1, homologation: { a: true } });
          await this.props.actions.fetchAccountVehicleCountApi({ homologation: { a: true } });
        }
      } else {
        const obj = JSON.parse(e.target.dataset.datos);
        const arrTags = [];

        obj.tags.forEach(item => {
          arrTags.push(item.tag);
        });

        this.setState({
          config: {
            id: obj.id,
            name: obj.alias,
            code: obj.code,
            extendedProperties: obj.extendedProperties,
            tags: arrTags,
            hom: obj.homologations
          },
          activeUpdate: false
        });
      }
    }
  };

  handleChange = e => {
    let config = { ...this.state.config };
    if(e.target.dataset.extendedPropertyId) {
      var extendedPropertiesValues = config["extendedProperties"];
      var found=false;
      for(var i=0; i<extendedPropertiesValues.length; i++) {
        if(extendedPropertiesValues[i].id==e.target.dataset.extendedPropertyId) {
          extendedPropertiesValues[i].value = e.target.value;
          found=true;
          break;
        }
      }
      if(found==false) {
        extendedPropertiesValues.push({id:e.target.dataset.extendedPropertyId, value: e.target.value})
      }
    }
    else {
      config[e.target.dataset.update] = e.target.value;
    }
    this.setState({
      config
    });
  };

  handleModalDownload = async e => {
    e.preventDefault();
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalDownload ? false : true;
      this.setState({ modalDownload: reset });
    }
  };

  handleDownload = async e => {
    await this.props.actions.fetchAccountVehicleDownloadApi();
    this.props.actions.resetModalFileVehicleAccount();
    this.setState({ modalDownload: false });
  };

  handleModalUpdate = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalUpdate ? false : true;
      this.setState({ modalUpdate: reset });
      if (!reset) {
        if (this.props.statusFile == 200) {
          document.getElementById('search').value = '';
          this.setState({ pag: 1 });
          this.setState({
            homologation: { a: true, b: false, c: false, d: false, e: false }
          });
          await this.props.actions.fetchAccountVehicleApi({ pag: 1, homologation: { a: true } });
          await this.props.actions.fetchAccountVehicleCountApi({ homologation: { a: true } });
        }
        this.props.actions.resetModalFileVehicleAccount();
        if (this.props.statusFile == null) {
          document.getElementById('file-error').classList.add('none');
          document.getElementById('file').value = '';
          document.getElementById('file-1').innerHTML = '';
          document.getElementById('btn-upload').classList.remove('active');
        }
      }
    }
  };

  handleUploadValue = async e => {
    const fullPath = document.getElementById('file').value;
    const btnUpload = document.getElementById('btn-upload');
    let extensionArr = fullPath.split('.');
    extensionArr = extensionArr[extensionArr.length - 1];
    if (
      (fullPath !== '' && extensionArr.toLowerCase() === 'xlsx') ||
      extensionArr.toLowerCase() === 'xls'
    ) {
      btnUpload.classList.add('active');
      document.getElementById('file-error').classList.add('none');
    } else {
      btnUpload.classList.remove('active');
      if (fullPath !== '') {
        document.getElementById('file-error').classList.remove('none');
      } else {
        document.getElementById('file-error').classList.add('none');
      }
    }
    document.getElementById('file-1').innerHTML = fullPath;
  };

  handleUpload = async e => {
    const btnUpload = document.getElementById('btn-upload');
    if (btnUpload.classList.contains('active')) {
      const fullPath = document.getElementById('file').files;
      await this.props.actions.fetchAccountVehicleUploadApi({});
    }
  };

  handleTagsFilter = async event => {
    const select = event.target.dataset.select;
    const parent = event.target.dataset.parent;
    const category = event.target.dataset.category;
    const value = document.getElementById('search').value;
    const tags = this.state.tags;

    const index = this.state.tags
      .map(function(e) {
        return e.category;
      })
      .indexOf(category);
    const arr = [];

    document.getElementById(parent).innerHTML = `
      <span class="dropdown-title">${strings.filter[event.target.dataset.category]}:</span>
      <div class="dropdown-subtitle">${event.target.innerHTML}</div>
    `;

    if (index >= 0) {
      if (select != '*') {
        tags.push({ name: select, category: category });
      }
      tags.splice(index, 1);
    } else {
      if (select != '*') {
        tags.push({ name: select, category: category });
      }
    }

    tags.forEach(item => {
      arr.push(item.name);
    });

    this.setState({ tags: tags });
    this.setState({ arrTags: arr });

    await this.props.actions.fetchAccountVehicleNoLoadingApi({
      filter: value,
      sort: this.state.sort,
      pag: 1,
      concat: false,
      homologation: this.state.homologation,
      tags: arr
    });
    await this.props.actions.fetchAccountVehicleCountApi({
      filter: value,
      homologation: this.state.homologation,
      tags: arr
    });
  };

  handleActive = async event => {
    const code = document.getElementById('idactive').value;
    await this.props.actions.handleActiveVehicle({ id: code });
  };

  render() {
    if (this.props.setting) {
      const obj = JSON.parse(this.props.setting.value);
      const language = this.props.language ? this.props.language.filter : '';

      const button = localStoreFN().getItem('permits');
      const buttonShow = button.includes('vehiclescrud');

      return (
        <section className="main" onScroll={this.handleScroll}>
          <Header handleSearch={this.handleSearch} language={language} />
          {this.props.loading || this.props.loadingDatasource ? (
            <Loading language={this.props.language} />
          ) : this.props.status === 401 ||
            this.props.statusDatasource === 401 ||
            this.props.statusSave === 401 ||
            this.props.statusTags === 401 ? (
            <Expired
              history={this.props.history}
              language={this.props.language ? this.props.language : ''}
            />
          ) : this.props.status === 200 &&
            this.props.statusDatasource === 200 &&
            this.props.statusTags === 200 ? (
            this.props.datos ? (
              <div className="main-container scroll">
                <Title language={this.props.language ? this.props.language : ''} />
                <Buttons
                  buttonShow={buttonShow}
                  handleHomologation={this.handleHomologation}
                  homologation={this.state.homologation}
                  handleModal={this.handleModal}
                  handleModalDownload={this.handleModalDownload}
                  handleModalUpdate={this.handleModalUpdate}
                  filter={this.props.filter}
                  handleTagsFilter={this.handleTagsFilter}
                  language={this.props.language ? this.props.language : ''}
                />
                <Table
                  buttonShow={buttonShow}
                  handleSort={this.handleSort}
                  pag={this.state.pag}
                  count={this.props.count}
                  tags={ObjGeneral.unionArrays(obj.generalSetting.filter, ObjGeneral.getIsEnabledUbicationPVT(obj) ? [constants.ubicationPVT.toLowerCase()] : null)}
                  loadingTable={this.props.loadingTable}
                  datos={this.props.datos}
                  handleModal={this.handleModalEdit}
                  handleModalDelete={this.handleModalDelete}
                  handleModalActive={this.handleModalActive}
                  language={this.props.language ? this.props.language : ''}
                />
                <ModalCreate
                  filter={this.props.filter}
                  handleSubmit={this.handleSubmit}
                  handleModal={this.handleModal}
                  modal={this.state.modal}
                  datosDatasource={this.props.datosDatasource}
                  statusSave={this.props.statusSave}
                  loadingSave={this.props.loadingSave}
                  dataSave={this.props.dataSave}
                  language={this.props.language ? this.props.language : ''}
                  extendedProperties={this.props.extendedProperties}
                  setting={this.props.setting}
                />
                <ModalEdit
                  activeUpdate={this.state.activeUpdate}
                  handleChange={this.handleChange}
                  filter={this.props.filter}
                  handleSubmit={this.handleUpdate}
                  handleModal={this.handleModalEdit}
                  modal={this.state.modalEdit}
                  datosDatasource={this.props.datosDatasource}
                  statusSave={this.props.statusSave}
                  loadingSave={this.props.loadingSave}
                  dataSave={this.props.dataSave}
                  config={this.state.config}
                  language={this.props.language ? this.props.language : ''}
                  extendedProperties={this.props.extendedProperties}
                  setting={this.props.setting}
                />
                <ModalDelete
                  handleSubmit={this.handleDelete}
                  handleModal={this.handleModalDelete}
                  modal={this.state.modalDelete}
                  statusSave={this.props.statusSave}
                  loadingSave={this.props.loadingSave}
                  dataSave={this.props.dataSave}
                  config={this.state.config}
                  language={this.props.language ? this.props.language : ''}
                />
                <ModalActive
                  handleSubmit={this.handleActive}
                  handleModal={this.handleModalActive}
                  modal={this.state.modalActive}
                  statusSave={this.props.statusSave}
                  loadingSave={this.props.loadingSave}
                  dataSave={this.props.dataSave}
                  config={this.state.config}
                  language={this.props.language ? this.props.language : ''}
                />
                <ModalDownload
                  handleModal={this.handleModalDownload}
                  modal={this.state.modalDownload}
                  handleDownload={this.handleDownload}
                  language={this.props.language ? this.props.language : ''}
                />
                <ModalUpdate
                  handleDownload={this.handleDownload}
                  handleUpload={this.handleUpload}
                  handleUploadValue={this.handleUploadValue}
                  handleModal={this.handleModalUpdate}
                  modal={this.state.modalUpdate}
                  datos={this.props.datosFile}
                  loading={this.props.loadingFile}
                  status={this.props.statusFile}
                  language={this.props.language ? this.props.language : ''}
                />
              </div>
            ) : (
              <Message message="NO DATA" />
            )
          ) : this.props.status === 500 ||
            this.props.statusDatasource === 500 ||
            this.props.statusTags === 500 ? (
            <Message message={this.props.language.error.apiError500} />
          ) : (
            <Message message={this.props.language.error.apiError} />
          )}
        </section>
      );
    } else {
      return (
        <section className="main">
          <Message message="NO Setting" />
        </section>
      );
    }
  }
}

const mapStateToProps = state => ({
  filter: ObjGeneral.unionFilters(state.reducer.tags.filter, Object.keys(state.reducer.tags.filterUbicationPVT).length > 0 ? [state.reducer.tags.filterUbicationPVT] : null),
  loadingFilter: state.reducer.tags.loading,
  statusTags: state.reducer.tags.status,

  setting: state.reducer.dashboard.setting,

  datos: state.reducer.accountVehicle.datos,
  extendedProperties: state.reducer.accountVehicle.extendedProperties,
  count: state.reducer.accountVehicle.count,
  loading: state.reducer.accountVehicle.loading,
  loadingTable: state.reducer.accountVehicle.loadingTable,
  loadingSave: state.reducer.accountVehicle.loadingSave,
  language: state.reducer.dashboard.language,
  status: state.reducer.accountVehicle.status,

  datosDatasource: state.reducer.datasource.datos,
  loadingDatasource: state.reducer.datasource.loading,
  statusDatasource: state.reducer.datasource.status,

  //loadingSave: state.reducer.accountVehicle.loadingSave,
  statusSave: state.reducer.accountVehicle.statusSave,
  dataSave: state.reducer.accountVehicle.dataSave,

  datosFile: state.reducer.accountVehicle.datosFile,
  loadingFile: state.reducer.accountVehicle.loadingFile,
  statusFile: state.reducer.accountVehicle.statusFile
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(accountVehicleActions, dispatch),
  tagsActions: bindActionCreators(tagsActions, dispatch),
  datasourceActions: bindActionCreators(datasourceActions, dispatch)
});

AccountVehicle.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountVehicle);



// WEBPACK FOOTER //
// ./source/client/containers/account_vehicle/index.jsx